<template>
  <div class="choose-item">
    <div>
      <img :src="photoUrl">
    </div>
    <div class="be-you-btn" :class="btnClass" v-on:click="redirect">{{btnText}}</div>
  </div>
</template>

<script>
export default {
  name: 'ChooseItem',
  props: {
    id: String,
    photoUrl: String,
    btnClass: String,
    btnText: String,
    route: false
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    redirect: function () {
      this.$emit('choose', this.id)
      if (this.route) {
        this.$router.push(this.route)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .choose-item {
    padding-top: 50px;
    img {
      padding-bottom: 20px;
      max-width: 100%;
    }
    @media (max-width: $breakpoint-sm) {
      padding-top: 40px;
      .be-you-btn {
        font-size: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/ChooseItem.vue